import { LanguagePack } from "@buzzeasy/shared-frontend-utilities";
import React from "react";

export type TranslationOverrideContextValue = [LanguagePack | null, React.Dispatch<React.SetStateAction<LanguagePack | null>>];

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const TranslationOverrideContext = React.createContext<TranslationOverrideContextValue>(undefined!);
